import { Button, InfoPage } from "@shapr3d/frontend-lib";

import useNavigation from "../hooks/navigation";

export const SSOGeneralErrorPage: React.FC = () => {
  const navigation = useNavigation();

  return (
    <InfoPage
      variant="warning"
      title="Something went wrong"
      primaryCTA={<Button onClick={() => navigation.goToSignIn()}>Back to log in</Button>}
    />
  );
};
